import { AgxHeader } from '@urbanx/agx-ui-components';
import './reporting.scss';
import clsx from 'clsx';

interface KeyMetricsButtonProps {
  onClick: () => void;
  isActive: boolean;
}

const KeyMetricsButton = ({ onClick, isActive }: KeyMetricsButtonProps) => {
  const styles = clsx('key-metrics-header', {
    activeHeader: isActive,
    inactiveHeader: !isActive,
  });

  return (
    <div className={styles} onClick={onClick}>
      <AgxHeader size={5}>Key Metrics</AgxHeader>
    </div>
  );
};

export default KeyMetricsButton;
